import Action from '../../Action'
import './styles/ModalDeleteUSer.css'
import { useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalDeleteMasive =({handleShowPopup,languaje,mode,buscar_cis,poolObjectRows,closDeleteUserModal,setData,setLoading,setError,server})=>{
  const [loadingM,setLoadingM]=useState(false);
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const [responseDelete,setResponseDelete]=useState([])
  const [statusResponseDelete,setStatusResponseDelete]=useState(false)
  const Eliminar=()=>{
    const host_list = { hostids: poolObjectRows.map(item => item.id) };
    setLoadingM(true)
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/hosts/mass_delete', {
       method: 'POST',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
       body:JSON.stringify(host_list)
     });
     if (response.ok) {
       const data1 = await response.json();
       setLoadingM(false)
       // Manejo de la respuesta
       setData(data1)
       setStatusResponseDelete(true)
       setResponseDelete(data1.data)
       buscar_cis()
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regDeleteCorr'])),'', true)
       // closDeleteUserModal()

       // console.log(data1);
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        // Manejo de errores
        handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
        setError(error)
        console.error(error);
      }
    };

    fetchDataPost();
  }
  return(
      <div className="modal-GS-content">
          <div className='card-modal-gs delete-modal-gs'>
                          {/* <div className='head-card-users delete-modal-gs'>
                              <div className='title-head-card-modal-gs'>
                                 CERRAR EXCEPCION
                              </div>
                          </div> */}
                          <div className='content-card-modal-gs' style={{height: '100%'}}>
                              <div className='cont-info-modal-delete-gs'>
                                  <div className='cont-message-modal-delete-gs' style={{height: '10%'}}>
                                          <div className='txt-message-modal-delete-gs'>
                                              {lang[languaje]['eliminar'].toUpperCase()+" ("+Object.keys(poolObjectRows).length+") "+lang[languaje]['dispositivos'].toUpperCase()}:
                                          </div>
                                  </div>
                                  <div className='cont-user-modal-delete-gs' style={{height: '80%'}}>
                                  <div className="cont-table-portafolio">
    <div className={"head-table-portafolio"+mode} style={{background:'var(--error-color)'}}>
    <div className="compact-head-table-portafolio">
   
      {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
      <div className="field-head-table-mantenimiento field-medium" style={{width:'30%'}} >{'ID'} </div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'70%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])}</div>
      {
        statusResponseDelete?
        <div className="field-head-table-mantenimiento field-larger" style={{width:'30%'}}>{'status'}</div>:''
      }
      </div>
    </div>
    <div className="body-table-portafolio">
    <div className="cont-row-user-list">
    {false ? (
        <div className="cont-load-user-list">
          <LoadSimple></LoadSimple>
        </div>
      ) : (
        
         statusResponseDelete?
         responseDelete.map((elemento, indice) => (
          <div
            className={"row-table-portafolio"+mode}
            key={indice}
          >
             
            {/* <div className="field-body-table-mantenimiento field-small">
              {elemento.hostid}
            </div> */}
            <div className="field-body-table-mantenimiento field-larger" style={{width:'30%'}}>
              {elemento.hostid}
            </div>
            <div className="field-body-table-mantenimiento field-medium" style={{width:'70%'}} >
              {elemento.host}
            </div>
            <div className="field-body-table-mantenimiento field-medium" style={{width:'30%',color:(elemento.success)?'green':'red'}} >
              {elemento.result}
            </div>
            
            
            
          </div>
        )): poolObjectRows.map((elemento, indice) => (
            <div
              className={"row-table-portafolio"+mode}
              key={indice}
            >
               
              {/* <div className="field-body-table-mantenimiento field-small">
                {elemento.hostid}
              </div> */}
              <div className="field-body-table-mantenimiento field-larger" style={{width:'30%'}}>
                {elemento.id}
              </div>
              <div className="field-body-table-mantenimiento field-medium" style={{width:'70%'}} >
                {elemento.name}
              </div>
              
              
              
            </div>
          ))
      )}
</div>
    {/* {
         poolObjectRows.map((element,index)=>(
                                                  <div className='txt-user-modal-delete-gs'>
                                                      
                                              {element.id + " - "+element.name}
                                          </div>
                                              ))
                                          } */}
    </div>
  </div>
                                          
                                  </div>
                                  <div className='cont-btn-modal-delete-gs' style={{height: '10%'}}>
                                          {
                                              (loadingM)?<LoadSimple></LoadSimple>:
                                              <>
                                              {(statusResponseDelete)?'':
                                              <Action  disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['eliminar'])}  action={Eliminar}></Action>}
                                          <Action  disabled={false} origen='Cancelar' titulo={(statusResponseDelete)?'Aceptar':'Cancelar'}  action={closDeleteUserModal}></Action>
                                              </>
                                          }
                                  </div>
                              </div>
                          </div>
          </div>
      </div>
  )
}

export default ModalDeleteMasive